import { EMPTY_ARR } from '@constants';

import useQuery from './useQuery';

import api from '..';

export const useAudiences = (_, queryConfig = {}) => {
  const queryResult = useQuery(['audiences'], api.audiences.getList, queryConfig);

  return {
    audiences: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

export const useSegments = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['segments', { id }], api.audiences.getSegments, queryConfig);

  return {
    segments: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};
